import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from "../../../../constants/url";
import style from './HospitalLinkComplete.module.css';



const HospitalLinkComplete = () => {

    const location = useLocation();

    const navigate = useNavigate();

    const { state } = location;

    //console.log( " =============>  HospitalLinkComplete state :  ", state );

    const patientSettingComplete = () => {

        const patientTag = [];

        let selectIdx = 1;
        state.forEach( (item) => {

            patientTag.push(
                <li key={selectIdx}>
                     <p>{ item.cnncHsptlNm }</p>
                     <span>{ item.cnncPatntNo }</span>
                </li>
            )
            selectIdx++;
        });

        return patientTag;
    }

    return (
        <>

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">


                    <div className={style['mid-box']}>
                        <div className='animation-2'>
                            <p className={style['top']}>
                                <b>회원번호 연동</b>이<br />
                                <b>완료</b>되었습니다
                            </p>

                            <div className={style['botm']}>
                                <ul>
                                    {
                                        state.length > 0 &&

                                        patientSettingComplete()
                                    }
                                    {/*
                                    <li>
                                        <p>서울성모병원</p>
                                        <span>10254384</span>
                                    </li>
                                    <li>
                                        <p>인천성모병원</p>
                                        <span>15468523</span>
                                    </li>
                                    <li>
                                        <p>대전성모병원</p>
                                        <span>25798535</span>
                                    </li>
                                    */}
                                </ul>
                            </div>
                        </div>
                    </div>



                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">

                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => navigate(URL.HOME_CARE_MAIN)}>
                                    <span>케어플러스 시작하기</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>

        </>
    )
}

export default HospitalLinkComplete
